import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { getBoxSizeDisplay } from "../../../utils/boxPricing";

/**
 * Simplified OrderCard for displaying a single product in an order list/summary.
 */
const OrderCard = ({ item }) => {
  return (
    <Box sx={{ py: 2 }}>
      <Grid container spacing={2} alignItems="center">
        {/* Product Image */}
        <Grid item xs={3} sm={2} md={1.5}>
          <img
            className="w-full aspect-square object-cover rounded-md border"
            src={item?.product?.imageUrl}
            alt={item?.product?.title}
          />
        </Grid>

        {/* Product Info */}
        <Grid item xs={9} sm={7} md={8.5}>
          <Typography variant="body1" fontWeight="600" noWrap>
            {item?.product?.title}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Size: <Box component="span" fontWeight="500" color="text.primary">{getBoxSizeDisplay(item?.size)}</Box>
            {" | "}
            Qty: <Box component="span" fontWeight="500" color="text.primary">{item?.quantity}</Box>
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, display: { xs: 'block', sm: 'none' } }}>
            ${item?.discountedPrice?.toFixed(2) || item?.price?.toFixed(2)}
          </Typography>
        </Grid>

        {/* Price (Desktop) */}
        <Grid item xs={12} sm={3} md={2} sx={{ textAlign: { sm: "right" }, display: { xs: 'none', sm: 'block' } }}>
          <Typography variant="body1" fontWeight="bold" color="primary.main">
            ${item?.discountedPrice?.toFixed(2) || item?.price?.toFixed(2)}
          </Typography>
          {item?.discountedPrice < item?.price && (
            <Typography
              variant="caption"
              sx={{ textDecoration: "line-through", color: "grey.500" }}
            >
              ${item?.price?.toFixed(2)}
            </Typography>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default OrderCard;
